import React, { ReactNode } from "react";
import "./style.scss";

interface BannerProps {
  children: ReactNode;
  className?: string;
}
function Banner({ children = <>Banner</>, className = "" }: BannerProps) {
return <div className={`mooc-std-banner ${className}`}>{children}</div>;
}

export default Banner;
